import { atom, map } from 'nanostores';

const $hasMenuOpen = atom(false);
const $hasPlayerOpen = map({
    state: false,
    id: null
});
const $hasGalleryOpen = map({
    state: false,
    id: null
});
const $isAutoplayable = atom(true);

export { $hasMenuOpen, $hasPlayerOpen, $hasGalleryOpen, $isAutoplayable };
